export default __webpack_public_path__ + "static/media/lion.a02db924.svg";